import { ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"

import { withSettings } from "hocs/features"

const SettingsComponent = () => {
  return null
}

export default compose<ComponentType>(withSettings)(SettingsComponent)
